var preset = {
  borderRadius: {
    8: '8px',
    16: '16px',
    24: '24px',
    round: '50%'
  }
};

export { preset as default };
